export default __webpack_public_path__ + "static/2-funds-payback-08f70149b838442651e04ff83f237cae.jpg";